import { bisector, extent, min } from 'd3-array'
import moment from 'moment'
import { commonColors, graphYearAgo } from '../../utils/constants'

const FINANCIAL = 'financial_data'
const flattenLayers = (layers) => layers.reduce((prev, cur) => [...prev, ...(cur?.data ?? [])],[])
export const getDate = (d) => new Date(d?.date)
export const getValue = (d) => d?.value
export const bisectDate = bisector((d) => new Date(d.date)).center
export const bisectDateLeft = bisector((d) => new Date(d.date)).left
export const bisectDateRight = bisector((d) => new Date(d.date)).right
export const roundDateDay = (dd) => {
    const d = new Date(dd)
    d.setHours(d.getHours() + 12)
    d.setHours(0, 0, 0, 0)
    return d
}
export const getLayersExtents = (layers, accessor) => {
    const flatData = flattenLayers(layers)
    return extent(flatData, accessor)
}

export const marginToPaddingStyles = (margin) => ({
    paddingRight: margin.right,
    paddingTop: margin.top,
    paddingLeft: margin.left, 
    paddingBottom: margin.bottom,
    height: '100%',
    width: '100%',
})

export const getInitialBrushRange = (layers, timeFrame) => {
    let start = moment(new Date())
    let end = moment()
    if(timeFrame?.daysBack) {
        start = start.clone().subtract(timeFrame.daysBack, 'days').valueOf()
    }
    else if(timeFrame?.start && timeFrame?.start) {
        start = moment(timeFrame.start)
        end = moment(timeFrame.end)
    }
    else{
        const layersToExtent = layers.length === 1 ? layers  : layers.filter(layer => !layer.dataset !== FINANCIAL)
        const layersMinDate = getDate(min(flattenLayers(layersToExtent)))
        start = moment(layersMinDate).isBefore(graphYearAgo) ? graphYearAgo : layersMinDate
    }
    return [ start, end ]
}

export const decorateLayers = (datasetColors, layers, graphLegend, params = { color: true, display: true, name: true }) => {
    const dataColors = [...datasetColors]
    const defaultColor = commonColors.data0

    return layers.map(layer => {
        const decorated = { ...layer }
        if (params.color) {
            if (layer.dataset === FINANCIAL || !dataColors.length) {
                decorated.color = defaultColor
            } else {
                decorated.color = dataColors.splice(0,1)
            }
        }
        if (params.display) {
            if (params.display === true) {
                decorated.display = layer.dataset === FINANCIAL ? 'area' : 'line'
            } else {
                decorated.display = params.display
            }
        }
        if (graphLegend) {
            const value = layer.column || layer.name || layer.dataset
            decorated.name = graphLegend.find(field => field.columnValue === value || field.columnName === value)?.columnName || value
        }
        else if (params.name) {
            decorated.name = layer.column || layer.name || layer.dataset
        }
        return decorated
    })
}

export const checkIfSameDate = (date, dateToCompare) =>  moment(date).isSame(moment(dateToCompare))
